var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import i18next from '../../strings/i18n/i18n';
import AlertsLazyLoader from '../../ui/molecules/AlertsLazyLoader';
import AlertsPageView from './subcomponents/PageToRender';
import { authorizationFailed, authorizationSuccess, setAccountId } from '../../redux/authorization/reducer';
import SyfStorage from '../../helpers/SyfStorage';
import { PAY_LATER_PRODUCT_TYPE, RESTRICTED_PRODUCT_TYPE } from '../../const/alertsConfig';
import responseCodes from '../../const/responseCodes';
import AlertsNotAvailableInfo from '../AlertsNotAvailableInfo';
import { useAlerts, usePageLoadStatus } from '../../ui/customHooks';
import SelectAccountDropdown from '../../ui/molecules/SelectAccountDropdown';
import { LayOutWrapper, Title } from './subcomponents';
import { useFeatureFlag } from '../../context/FeatureFlag';
import setFeatureFlags from '../../context/FeatureFlag/setFeatureFlags';
import isAccountEligibleForAlertsList from '../../helpers/isAccountEligibleForAlertsList';
import isPlatformPeaks from '../../helpers/isPlatformPeaks';
var AlertsPage = React.lazy(function () { return import('../Alerts'); });
var VistaApp = function () {
    var _a, _b, _c, _d;
    var dispatch = useDispatch();
    var isPageLoaded = usePageLoadStatus();
    var _e = useState(true), showAlertList = _e[0], setShowAlertList = _e[1];
    var _f = useFeatureFlag(), payLaterFlag = _f.state.payLater, dispatchFeatureFlag = _f.dispatch;
    var _g = useAlerts(), appConfig = _g.appConfig, isAuthorized = _g.isAuthorized, syfIdentifier = _g.syfIdentifier, accountsInfo = _g.accountsInfo, accountId = _g.accountId;
    var platform = appConfig.platform, config = appConfig.config;
    var selectedAccount = (accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo.find(function (account) { return (account === null || account === void 0 ? void 0 : account.accountId) === syfIdentifier; })) ||
        (accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo[0]);
    var clientId = (_a = selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.product) === null || _a === void 0 ? void 0 : _a.clientId;
    var displayName = (_b = selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.product) === null || _b === void 0 ? void 0 : _b.displayName;
    var accountLast4 = (_c = selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountInfo) === null || _c === void 0 ? void 0 : _c.accountLast4;
    var analyticsAccountInfoMessage = "".concat(displayName, " ending in ").concat(accountLast4);
    var productType = (_d = selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.product) === null || _d === void 0 ? void 0 : _d.type;
    var isPayLater = PAY_LATER_PRODUCT_TYPE.includes(productType);
    var isAccountEligible = isAccountEligibleForAlertsList(payLaterFlag || isPlatformPeaks(platform), isPayLater);
    useEffect(function () {
        var _a;
        var token = SyfStorage.getAccessToken();
        if (token) {
            // vista uses the accountId for the syfIdentifier
            dispatch(authorizationSuccess(token));
            if (accountId) {
                dispatch(setAccountId(accountId));
                var account = accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo.find(function (acc) { return acc.accountId === accountId; });
                var restrictedProduct = RESTRICTED_PRODUCT_TYPE.includes((_a = account === null || account === void 0 ? void 0 : account.product) === null || _a === void 0 ? void 0 : _a.type);
                setShowAlertList(!restrictedProduct);
            }
        }
        else {
            dispatch(authorizationFailed("".concat(responseCodes.INTERNAL_SERVER_ERROR)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accountId]);
    useEffect(function () {
        setFeatureFlags(dispatchFeatureFlag);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var accountDropdown = (accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo.length) > 1 && (_jsx(SelectAccountDropdown, { accountsInfo: accountsInfo, setShowAlertList: setShowAlertList, syfIdentifier: syfIdentifier }));
    var alertsPage = isAuthorized &&
        (showAlertList && isAccountEligible ? (_jsx(AlertsPage, { analyticsAccountInfoMessage: analyticsAccountInfoMessage, appConfig: appConfig, clientId: clientId, isPageLoaded: isPageLoaded, productType: productType, syfIdentifier: syfIdentifier })) : (_jsx(AlertsNotAvailableInfo, { analyticsAccountInfoMessage: analyticsAccountInfoMessage, clientId: clientId, isPageLoaded: isPageLoaded, mfeConfig: config, platform: platform })));
    var pageToRender = (_jsx(AlertsPageView, { accountDropdown: accountDropdown, alertsPage: alertsPage, analyticsAccountInfoMessage: analyticsAccountInfoMessage, clientId: clientId, isPageLoaded: isPageLoaded }));
    return (_jsx(LayOutWrapper, __assign({ "data-test": "LayOutWrapper" }, { children: _jsx(Suspense, __assign({ fallback: _jsx(AlertsLazyLoader, {}) }, { children: _jsxs("div", __assign({ "data-test": "MainWrapper" }, { children: [_jsx(Title, { children: i18next.t('headerLabels.alertsManagement') }), pageToRender] })) })) })));
};
export default VistaApp;
